import { ChannelType } from '../enums/ChannelType';
import { ChannelListFilterItem } from '../types/ChannelListFilterItem';

export const filterSelectedChannelTypes = (channelListFilterItem: ChannelListFilterItem[]) => {
    return channelListFilterItem.reduce<ChannelType[]>((acc, itm) => {
        return itm.isActive ? [...acc, itm.value] : acc;
    }, []);
};

export const channelTypeToLabel = (channelType: ChannelType) => {
    switch (channelType) {
        case ChannelType.system:
            return 'System';
        case ChannelType.webEvents:
            return 'Web';
        case ChannelType.formRequests:
            return 'Form Request';
        case ChannelType.ePlans:
            return 'ePlan';
        case ChannelType.listingEvents:
            return 'Listing';
        case ChannelType.callEvents:
            return 'Call';
        case ChannelType.gmailEvents:
            return 'Gmail Email';
        case ChannelType.messageEvents:
            return 'Text Message';
        case ChannelType.externalRequests:
            return 'External Request';
        case ChannelType.actionPlans:
            return 'Action Plan';
        case ChannelType.webPushEvents:
            return 'Web Push';
        default:
            return 'Other';
    }
};
